document.addEventListener('DOMContentLoaded', function () {

  // Dictionnaire couleur -> code hexa. Ajoute/modifie des lignes ici librement.
  var colorMap = {
    'noir': '#000000',
    'blanc': '#FFFFFF',
    'gris': '#9A9A9A',
    'argent': '#C0C0C0',
    'or': '#D4AF37',
    'dore': '#D4AF37',
    'marron': '#6F4E37',
    'chocolat': '#3C1E10',
    'taupe': '#B38B6D',
    'camel': '#C19A6B',
    'cognac': '#9A463D',
    'beige': '#D8C3A5',
    'ivoire': '#FFFFF0',
    'ecru': '#F5F3E7',
    'rouge': '#E30613',
    'bordeaux': '#6D071A',
    'rose': '#F7A8B8',
    'fuchsia': '#FF00FF',
    'orange': '#FF8200',
    'jaune': '#FFD400',
    'moutarde': '#C9A227',
    'vert': '#2E8B57',
    'kaki': '#78866B',
    'turquoise': '#30D5C8',
    'bleu': '#0072CE',
    'marine': '#002147',
    'violet': '#7D3C98',
    'mauve': '#B784A7',
    'lilas': '#C8A2C8',
    'cuivre': '#B87333',
    'bronze': '#8C7853',
    'nude': '#E3BC9A',
    'multicolore': 'linear-gradient(90deg, red, orange, yellow, green, blue, violet)'
  };

  // Enlève les accents pour que "doré" matche la clé "dore"
  function stripAccents(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  var swatches = document.querySelectorAll('.variant-option-color .swatch span[data-variant-item]');

  swatches.forEach(function (swatch) {
    var raw = swatch.getAttribute('data-variant-item') || '';
    var cleaned = stripAccents(raw.toLowerCase());
    // Découpe en mots sur tout ce qui n'est pas une lettre (tirets, slashs, %, chiffres, espaces)
    var words = cleaned.split(/[^a-z]+/).filter(Boolean);

    var matched = false;

    for (var i = 0; i < words.length; i++) {
      if (colorMap.hasOwnProperty(words[i])) {
        var value = colorMap[words[i]];
        swatch.style.backgroundImage = 'none';
        if (value.indexOf('gradient') !== -1) {
          swatch.style.backgroundImage = value;
        } else {
          swatch.style.backgroundColor = value;
        }
        matched = true;
        // Pas de "break" : pour "bleu-marine", le mot "marine" (plus précis,
        // trouvé après "bleu") écrase le résultat précédent. C'est voulu.
      }
    }

    // Le thème ajoute une classe spéciale "bg-variant-image-as-color" dès
    // qu'un nom de couleur contient un tiret (ex: "bleu-marine"), et cette
    // classe force un affichage miniature pensé pour une photo. Comme on
    // vient d'appliquer une vraie couleur, on retire cette classe pour
    // retrouver la taille normale du rond.
    if (matched) {
      var swatchLink = swatch.closest('.swatch');
      if (swatchLink) {
        swatchLink.classList.remove('bg-variant-image-as-color');
      }
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  var input = document.querySelector('.discount-code');
  if (input) {
    input.placeholder = 'Entrez un code promo';
  }
});
document.addEventListener('DOMContentLoaded', function () {
  var target = 'Get shipping estimates';
  var replacement = 'Estimer les frais de livraison';

  document.querySelectorAll('*').forEach(function (el) {
    if (el.children.length === 0 && el.textContent.trim() === target) {
      el.textContent = replacement;
    }
  });
});
document.addEventListener('DOMContentLoaded', function () {
  var translations = {
    'Get shipping estimates': 'Estimer les frais de livraison',
    'Country': 'Pays',
    'Zip/Postal Code': 'Code postal',
    'Calculate shipping': 'Calculer les frais de livraison'
  };
  function translatePage() {
    document.querySelectorAll('*').forEach(function (el) {
      if (el.children.length === 0) {
        var text = el.textContent.trim();
        if (translations.hasOwnProperty(text)) {
          el.textContent = translations[text];
        }
      }
    });

    document.querySelectorAll('input[type="submit"], input[type="button"], button').forEach(function (el) {
      var val = (el.value || '').trim();
      if (translations.hasOwnProperty(val)) {
        el.value = translations[val];
      }
    });
  }

  translatePage();

  var observer = new MutationObserver(translatePage);
  observer.observe(document.body, { childList: true, subtree: true });
});

//CUSTOM PRICE RANGES (remplace le slider natif cassé)

document.addEventListener('DOMContentLoaded', function () {
  var ranges = [
    { label: '0 € - 50 €', gte: 0, lte: 50 },
    { label: '50 € - 100 €', gte: 50, lte: 100 },
    { label: '100 € et plus', gte: 100, lte: null }
  ];

  function buildRangeURL(gte, lte) {
    var params = new URLSearchParams();
    params.set('filter.v.price.gte', gte);
    if (lte !== null) params.set('filter.v.price.lte', lte);
    return window.location.pathname + '?' + params.toString();
  }

  function isActiveRange(gte, lte) {
    var params = new URLSearchParams(window.location.search);
    var currentGte = params.get('filter.v.price.gte');
    var currentLte = params.get('filter.v.price.lte');
    var gteMatch = currentGte !== null && parseFloat(currentGte) === gte;
    var lteMatch = lte === null ? currentLte === null : (currentLte !== null && parseFloat(currentLte) === lte);
    return gteMatch && lteMatch;
  }

  function injectPriceRanges(filterBlock) {
    if (filterBlock.dataset.customPriceInjected) return;
    filterBlock.dataset.customPriceInjected = 'true';

    var sidebarBody = filterBlock.querySelector('.sidebar-body');
    if (!sidebarBody) return;

    var list = document.createElement('ul');
    list.className = 'dt-sc-list custom-price-ranges';

    ranges.forEach(function (range) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = buildRangeURL(range.gte, range.lte);
      a.textContent = range.label;
      if (isActiveRange(range.gte, range.lte)) {
        a.classList.add('active');
      }
      li.appendChild(a);
      list.appendChild(li);
    });

    sidebarBody.appendChild(list);
  }

  function initCustomPriceFilter() {
    document.querySelectorAll('.js-filter[data-index="filter-price-2"]').forEach(injectPriceRanges);
  }

  initCustomPriceFilter();

  var filtersContainer = document.querySelector('.dt-collection-filter');
  if (filtersContainer) {
    var observer = new MutationObserver(initCustomPriceFilter);
    observer.observe(filtersContainer, { childList: true, subtree: true });
  }
});